"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { ApiNotificationsResponse } from "@/generated/models/ApiNotificationsResponse";
import { commonApiFetch } from "@/services/api/common-api";
import useCapacitor from "./useCapacitor";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
export function useUnreadNotifications(handle) {
  const $ = _c(14);
  const {
    isCapacitor
  } = useCapacitor();
  let t0;
  if ($[0] !== handle) {
    t0 = [QueryKey.IDENTITY_NOTIFICATIONS, {
      identity: handle,
      limit: "1"
    }];
    $[0] = handle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!handle;
  const t2 = !isCapacitor;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getDefaultQueryRetry();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t4 = {
      queryKey: t0,
      queryFn: _temp,
      enabled: t1,
      refetchInterval: 30000,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchIntervalInBackground: t2,
      ...t3
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: notifications
  } = useQuery(t4);
  const [haveUnreadNotifications, setHaveUnreadNotifications] = useState(false);
  let t5;
  if ($[7] !== notifications?.unread_count) {
    t5 = () => {
      setHaveUnreadNotifications(!!notifications?.unread_count);
    };
    $[7] = notifications?.unread_count;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== notifications) {
    t6 = [notifications];
    $[9] = notifications;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== haveUnreadNotifications || $[12] !== notifications) {
    t7 = {
      notifications,
      haveUnreadNotifications
    };
    $[11] = haveUnreadNotifications;
    $[12] = notifications;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
async function _temp() {
  return await commonApiFetch({
    endpoint: "notifications",
    params: {
      limit: "1"
    }
  });
}